const MAP = {
    "On Track": { bg: "#ECFDF5", text: "#047857", dot: "#10B981" },
    "Due Soon": { bg: "#FFFBEB", text: "#B45309", dot: "#F59E0B" },
    Overdue: { bg: "#FEF2F2", text: "#B91C1C", dot: "#EF4444" },
    Unknown: { bg: "#F3F4F6", text: "#6B7280", dot: "#9CA3AF" },
};

export default function OutreachHealthBadge({ value }) {
    const s = MAP[value] || MAP.Unknown;
    return (
        <span
            className="inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-[11px] font-medium"
            style={{ backgroundColor: s.bg, color: s.text }}
            data-testid={`outreach-health-${(value || "unknown").toLowerCase().replace(/\s/g, "-")}`}
        >
            <span className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: s.dot }} />
            {value || "Unknown"}
        </span>
    );
}
